const bookNowButtons = document.querySelectorAll('.js-book-now');

bookNowButtons.forEach((bookNowButton) => {
    const url = new URL(bookNowButton.dataset.href);

    bookNowButton.addEventListener('click', (event) => {
        window.location.href = url.href;
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const bookingInfoMessageEl = document.querySelector('.js-booking-info-message');

    if (null === bookingInfoMessageEl || 0 === bookingInfoMessageEl.children.length) {
        return;
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
});